import React from "react";
import axios from "../../../../axios";

const ResolveQueryLib = ({ setMarkQuery, data, }) => {
  let studentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const handleStatusChange = async () => {
    try {
      const res = await axios.put(`/query/updateStatus/${data?.id}`, {
        user_id: studentData?.id,
        updatedStatus: "resolved",
      });

      if (res.status === 200) {
        window.location.reload()
        setMarkQuery(false);
      }
    } catch (error) {
      console.log("Error resolving query:", error);
    }
  };

  return (
    <div className="delete_query_transprant_body">
      <img
        src="/images/cross-circle3.svg"
        className="delete_query_close_btn"
        alt="close"
        onClick={() => setMarkQuery(false)}
      />

      <div className="p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className="col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to mark this query as resolved?
          </span>

          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center">
            <button
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleStatusChange}
            >
              Yes
            </button>

            <button
              className="btn btn-secondary col-sm-5"
              onClick={() => setMarkQuery(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolveQueryLib;